module.exports = __webpack_public_path__ + "font5.0d41f797.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/font5.png
// module id = bfR+
// module chunks = 0